module.exports = "/assets/images/left-arrow-small_427dd9.svg";